import React, { useState } from 'react';
import toast from 'react-hot-toast';

interface AIHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}
interface HelpStep {
  text: string;
  images?: string[]; // เปลี่ยนจาก string เป็น array ของ string
}
const AIHelpModal: React.FC<AIHelpModalProps> = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState<'DIME' | 'WEBULL' | 'M1'>('DIME');
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  if (!isOpen) return null;

  const handleCopyPrompt = async (tab: 'DIME' | 'WEBULL' | 'M1') => {
    try {
      // โหลดไฟล์ JSON จาก public
      const response = await fetch('/prompts.json');
      const prompts = await response.json();

      // เลือกข้อความตามแท็บ
      const textToCopy = prompts[tab];

      await navigator.clipboard.writeText(textToCopy);
      toast.success(`${tab} Prompt คัดลอกแล้ว!`);
    } catch (error) {
      console.error("Error loading prompts:", error);
      toast.error("ไม่สามารถคัดลอก Prompt ได้");
    }
  };
const DOC_URLS = {
    DIME: "https://docs.google.com/document/d/1ei-pOTM1PjtnpSFhyxZCCTOViyDKmKYBvtiTmtjLmlc/edit?usp=sharing",
    WEBULL: "https://docs.google.com/document/d/15Vcmv-b4FAYU1AdtRMlSmfOq02AfkyJSdUcnoom-jGI/edit?usp=sharing",
    M1: "https://docs.google.com/document/d/1cCIFWkwd0m62Q5964Rcw3uSTuI8aqDG_MP4R1M3gh24/edit?usp=sharing"
  };
  const steps: Record<'DIME' | 'WEBULL' | 'M1', HelpStep[]> = {
    DIME: [
      { text: "เข้าสู่แอป DIME ไปยัง เมนู > รายการ", images: ["dime1.png"] },
      { text: "กดตัวกรองและตั้งค่ารายการตามความต้องการ ทำการแคปรูปผลการค้นหา (พยายามให้เห็น ชื่อหุ้น, ราคา, จำนวน, วันที่-เวลา)", images: ["dime2.png", "dime3.png"] },
      { text: "เปิด เครื่องมือ AI (ChatGPT, Gemini, Claude, etc...)" },
      { text: "คัดลอก Prompt ด้านล่างนี้(ในไฟล์ Docs) และกดส่งให้ AI เพื่อ Prompt" },
      { text: "นำรูปภาพที่แคปรายการลงทุนใส่ลงไปให้ AI (หากมากกว่า10รูป สามารถแบ่งเป็นหลายครั้งได้ แต่ต้องพิมพ์คำสั่งไปด้วยว่า \"add this more into recent .csv file\")" },
      { text: "หากได้ไฟล์ .csv เรียบร้อย ให้ทำการตรวจสอบและ Upload ที่เว็บในช่องนำเข้า(แนะนำให้ตรวจสอบในไฟล์ .csv ที่ได้มาจาก AI ก่อน Upload ลงเว็บช่อง)" }
    ],
    WEBULL: [
      { text: "เข้าสู่แอป Webull ไปยัง เมนู > เมนู > เอกสารสรุปข้อมูลบัญชี(บัญชี) > รายการย้อนหลัง", images: ["webull1.png", "webull2.png"] },
      { text: "ทำการดาวน์โหลดไฟล์ CSV ที่เกี่ยวข้องออกมา", images: ["webull3.png"] },
      { text: "เปิด เครื่องมือ AI (ChatGPT, Gemini, Claude, etc...)" },
      { text: "คัดลอก Prompt ด้านล่างนี้(ในไฟล์ Docs) และกดส่งให้ AI เพื่อ Prompt" },
      { text: "นำไฟล์ .csv ที่ได้จาก Webull ใส่ลงไปให้ AI" },
      { text: "หากได้ไฟล์ .csv เรียบร้อย ให้ทำการตรวจสอบและ Upload ที่เว็บในช่องนำเข้า(แนะนำให้ตรวจสอบในไฟล์ .csv ที่ได้มาจาก AI ก่อน Upload ลงเว็บช่อง)" }
    ],
    M1: [
      { text: "เข้าสู่แอป M1 ไปยัง Portfolio > หัวข้อด้านบน เลือก \"Holdings\" ", images: ["m11.png", "m12.png"] },
      { text: "ขวามือ สังเกตุ Download ให้คลิก จุด สาม จุด แล้วมันจะขึ้นมาให้โหลดได้ทั้ง 3 ตัวดังนี้", images: ["m13.png"] },
      { text: "เปิด เครื่องมือ AI (ChatGPT, Gemini, Claude, etc...)" },
      { text: "คัดลอก Prompt ด้านล่างนี้(ในไฟล์ Docs) และกดส่งให้ AI เพื่อ Prompt" },
      { text: "นำไฟล์ .csv ที่ได้จาก M1 ใส่ลงไปให้ AI" },
      { text: "หากได้ไฟล์ .csv เรียบร้อย ให้ทำการตรวจสอบและ Upload ที่เว็บในช่องนำเข้า(แนะนำให้ตรวจสอบในไฟล์ .csv ที่ได้มาจาก AI ก่อน Upload ลงเว็บช่อง)" }
    ]
  };
const handleOpenDocs = (tab: 'DIME' | 'WEBULL' | 'M1') => {
    const url = DOC_URLS[tab];
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      {selectedImage && (
        <div
          className="fixed inset-0 z-[310] flex items-center justify-center bg-black/90 p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)} // กดที่ไหนก็ได้เพื่อปิด
        >
          <img src={selectedImage} alt="Zoomed" className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl" />
        </div>
      )}

      <div className="bg-[#18181b] p-6 rounded-2xl w-full max-w-lg border border-gray-700 shadow-2xl flex flex-col max-h-[90vh]">
        {/* 1. เพิ่ม flex flex-col และ max-h-[90vh] ที่ container หลัก */}

        <div className="flex justify-between items-center mb-6 shrink-0">
          <h2 className="text-xl font-bold text-yellow-400">วิธีใช้งาน AI ช่วยทำไฟล์ .csv</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">✕</button>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 mb-6 bg-gray-800 p-1 rounded-lg shrink-0">
          {(['DIME', 'WEBULL', 'M1'] as const).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 py-2 text-sm font-bold rounded-md transition ${activeTab === tab ? 'bg-yellow-400 text-black' : 'text-gray-400 hover:text-white'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* 2. ส่วน Content นี้คือส่วนที่จะให้ Scroll */}
        <div className="space-y-6 mb-6 overflow-y-auto pr-2 custom-scrollbar flex-1">
          {steps[activeTab]?.map((step, idx) => (
            <div key={idx} className="space-y-2">
              <div className="flex gap-3 text-sm text-gray-300">
                <span className="font-bold text-yellow-500">{idx + 1}.</span>
                <p>{step.text}</p>
              </div>
              {step.images && step.images.length > 0 && (
  <div className="pl-7 flex flex-wrap gap-2 mt-2">
    {step.images.map((imgName, imgIdx) => {
      const imgSrc = `/${imgName}`;
      return (
        <img
          key={imgIdx}
          src={imgSrc}
          alt={`Step ${idx + 1} Image ${imgIdx + 1}`}
          // แก้ไขตรงนี้:
          // 1. นำ flex-grow ออก
          // 2. ใช้ w-[calc(50%-0.5rem)] เพื่อให้แต่ละรูปกว้างครึ่งหนึ่งของ container ลบด้วยช่องว่าง gap
          // 3. ใช้ object-contain เพื่อให้รูปแสดงทั้งภาพโดยไม่โดนตัด
          className="rounded-lg border border-gray-600 h-24 w-[calc(50%-0.5rem)] object-contain bg-black/20 shadow-lg cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => setSelectedImage(imgSrc)}
        />
      );
    })}
  </div>
)}
            </div>
          ))}
        </div>

        {/* 3. ปุ่มคัดลอก (เพิ่ม shrink-0 เพื่อไม่ให้ปุ่มโดนเบียดหายไป) */}
      <div className="shrink-0 flex flex-col gap-3"> {/* เปลี่ยนเป็น flex-col เผื่อซ้อนกันหลายปุ่ม */}
          <button
            onClick={() => handleOpenDocs(activeTab)}
            className="w-full py-3 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-lg transition-transform active:scale-95 shadow-md flex items-center justify-center gap-2"
          >
            <span>📝</span> เปิดเอกสาร Prompt {activeTab} สำหรับ AI
          </button>
         {/* ✅ ปุ่ม YouTube แบบมีแสง Glow กระพริบช้าๆ ดึงดูดสายตา */}
         {/* ✅ ปุ่ม YouTube แบบมีแสง Glow สีทอง กระพริบช้าๆ */}
          {activeTab === 'DIME' && (
            <div className="relative w-full group mt-1">
              {/* 🌟 แสง Glow สีเหลืองทอง กระพริบช้าๆ อยู่ด้านหลัง */}
              <div className="absolute inset-0 bg-green-500 rounded-lg blur-md opacity-50 animate-pulse group-hover:opacity-80 transition-opacity duration-300"></div>
              
              {/* 🔘 ตัวปุ่มหลัก (ไล่สีทอง-ส้ม ให้ดูมีมิติ) */}
              <button
                onClick={() => window.open('https://youtu.be/qjRLJl6H4pQ', '_blank', 'noopener,noreferrer')}
                className="relative w-full py-3 bg-gradient-to-r from-green-500 via-blue-300 to-green-500 text-gray-900 font-extrabold rounded-lg transition-all active:scale-95 shadow-[0_4px_15px_rgba(234,179,8,0.4)] flex items-center justify-center gap-2 hover:brightness-110 border border-green-300/50"
              >
                {/* ไอคอน Play สีเหลืองในวงกลมดำ */}
                <div className="flex items-center justify-center w-6 h-6 bg-gray-900 rounded-full shadow-inner">
                  <span className="text-green-400 text-[10px] ml-0.5">▶</span>
                </div>
                <span className="tracking-wide">ดูคลิปสอนวิธีทำ (ง่ายที่สุด!)</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AIHelpModal;